import { formatApiErrorDetail } from "@/lib/api";

export const cdrErr = (e, d) => formatApiErrorDetail(e?.response?.data?.detail) || d;
export const fmtWhen = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "");
export const fmtDay = (d) => (d ? new Date(`${d}T12:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "");
export const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const num = (n) => Number(n || 0).toLocaleString();
export const cycleText = (c) => (c ? `${c.label} · ${fmtDay(c.start)} → ${fmtDay(c.end)}` : "");

const TONE = {
  sent: "bg-emerald-50 text-emerald-700 border-emerald-200", done: "bg-emerald-50 text-emerald-700 border-emerald-200",
  paused: "bg-amber-50 text-amber-700 border-amber-200", running: "bg-sky-50 text-sky-700 border-sky-200",
  failed: "bg-rose-50 text-rose-700 border-rose-200",
};

export function Pill({ s, testid }) {
  return <span className={`inline-flex rounded-full border px-2 py-0.5 text-[11px] font-semibold capitalize ${TONE[s] || "bg-slate-50 text-slate-600 border-slate-200"}`} data-testid={testid}>{s === "paused" ? "held (e-mail paused)" : s}</span>;
}
